// import HTTP from '@/services/http-request-handler'
import axios from 'axios'
import store from '@/store'
// import {initialStateCopy} from '@/store'
import router from '@/router'
import vueCookie from 'vue-cookie'
import VueCookies from 'vue-cookies'

const authService = {
  login: (credentials) => {
    // return axios.post(process.env.API_PORT ? process.env.API_URL + ':' + process.env.API_PORT + '/auth/login' : process.env.API_URL + '/auth/login',
    return axios.post(JSON.parse(window.localStorage.ApiculusEnv).api.url + '/auth/login',
      // 'https://mycloudapi.nxtradata.com/auth/login'
      // 'http://cloudapi.apiculus.iqtest:33333/auth/login',
      credentials)
      .then((res) => {
        if (res.data.success) {
          return res.data
        }
      })
      .catch((err) => {
        vueCookie.delete('access-token')
        return err.response.data
      })
  },
  logout: () => {
    // return axios.post(process.env.API_PORT ? process.env.API_URL + ':' + process.env.API_PORT + '/auth/logout' : process.env.API_URL + '/auth/logout',
    return axios.post(JSON.parse(window.localStorage.ApiculusEnv).api.url + '/auth/logout',
      // 'https://mycloudapi.nxtradata.com/auth/logout'
      // 'http://cloudapi.apiculus.iqtest:33333/auth/logout',
      {}, { headers: { 'access-token': vueCookie.get('access-token') } })
      .then((res) => {
        vueCookie.delete('access-token')
        VueCookies.delete('access-token-key')
        store.commit('MUTATION_AUTH_LOGOUT')
        // console.log('here', initialStateCopy)
        // store.replaceState(initialStateCopy)
        return res.data
      })
      .catch((err) => {
        vueCookie.delete('access-token')
        VueCookies.delete('access-token-key')
        console.log('ERROR')
        store.commit('MUTATION_AUTH_ERROR')
        router.push('/')
        // store.replaceState(initialStateCopy)

        return err.response.data
      })
  },
  getState(data) {
    return axios.post(
      // 'http://localhost:33333/api/v1/getUserAccountState',data)
      JSON.parse(window.localStorage.ApiculusEnv).api.url +'/api/v1/getUserAccountState',data)
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        return err.response.data
      })
  }
}

export default authService
